export default __webpack_public_path__ + "static/media/36I-102777_-43414_0.c7949cc4.jpg";